// @flow
import classNames from "classnames";
import React, { PureComponent } from "react";

type Props = {
  height: number,
  width: number,
  className: any
};

class Copy extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 24 24`}>
        <title>Ícone copiar</title>
        <desc>Ícone de botão copiar</desc>
        <g id="icon-copy">
          <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"></path>
        </g>
      </svg>
    );
  }
}

export default Copy;
